import PropTypes from "prop-types";

const XIcon = ({ color = "white", bgColor = "#7B9E7E" }) => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.0878906"
        y="0.258301"
        width="29.9111"
        height="29.9111"
        rx="4.78577"
        fill={bgColor}
      />
      <path
        d="M17.6381 13.6481L24.7665 6.04102H22.0595L16.4646 12.0127L12.1797 6.04102H4.77539L12.2702 16.487L4.77539 24.4862H7.48239L13.4445 18.1233L18.0097 24.4862H25.414L17.6381 13.649V13.6481ZM8.5902 7.99677H11.1712L21.5983 22.5286H19.0173L8.5902 7.99677Z"
        fill={color}
      />
    </svg>
  );
};

const { string } = PropTypes;

XIcon.propTypes = {
  color: string,
  bgColor: string
};

export default XIcon;
